import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [instructor, setInstructor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // Ellenőrizzük, hogy a token érvényes-e (hálózati hibánál nem töröljük a tokent)
      axios.get('/api/auth/me')
        .then(response => {
          setIsAuthenticated(true);
          setInstructor(response.data.instructor);
        })
        .catch((err) => {
          const status = err.response?.status;
          if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const applySession = (token, instructor) => {
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setIsAuthenticated(true);
    setInstructor(instructor);
  };

  const login = async (usernameOrEmail, password) => {
    try {
      const isEmail = usernameOrEmail.includes('@');
      const loginData = isEmail
        ? { email: usernameOrEmail, password }
        : { username: usernameOrEmail, password };

      const response = await axios.post('/api/auth/login', loginData);
      const { token, instructor } = response.data;
      const role = (instructor?.accessRole || '').toLowerCase();
      const isPilotOnly = role === 'pilot' && !instructor?.isAdmin;

      if (isPilotOnly) {
        return { success: true, needsPilotConductAck: true, token, instructor };
      }

      applySession(token, instructor);
      return { success: true, instructor };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Login error'
      };
    }
  };

  const completeLoginAfterPilotConduct = (token, instructor) => {
    applySession(token, instructor);
  };

  const logout = () => {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    setInstructor(null);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        instructor,
        login,
        completeLoginAfterPilotConduct,
        logout,
        loading
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
